<template>
    <JetFormSection @submitted="updateSettingGaji">
        <template #title>Komponen Gaji</template>

        <template #description>Setting komponen gaji</template>

        <template #form>
            <!-- Tarif Tunjangan Beras -->
            <div class="col-span-6 sm:col-span-4">
                <JetLabel
                    for="tarif_tunjangan_beras"
                    value="Tarif Tunj Beras"
                />
                <Input
                    id="tarif_tunjangan_beras"
                    type="text"
                    class="mt-1 block w-full"
                    v-model="form.tarif_tunjangan_beras"
                    autocomplete="tarif_tunjangan_beras"
                />
                <JetInputError
                    :message="form.errors.tarif_tunjangan_beras"
                    class="mt-2"
                />
            </div>

            <!-- Persen Tunjangan Pasangan -->
            <div class="col-span-6 sm:col-span-4">
                <JetLabel
                    for="persen_tunjangan_pasangan"
                    value="Persen Tunj Pasangan"
                />
                <Input
                    id="persen_tunjangan_pasangan"
                    type="text"
                    class="mt-1 block w-full"
                    v-model="form.persen_tunjangan_pasangan"
                    autocomplete="persen_tunjangan_pasangan"
                />
                <JetInputError
                    :message="form.errors.persen_tunjangan_pasangan"
                    class="mt-2"
                />
            </div>

            <!-- Persen Tunjangan Anak -->
            <div class="col-span-6 sm:col-span-4">
                <JetLabel
                    for="persen_tunjangan_anak"
                    value="Persen Tunj Anak"
                />
                <Input
                    id="persen_tunjangan_anak"
                    type="text"
                    class="mt-1 block w-full"
                    v-model="form.persen_tunjangan_anak"
                    autocomplete="persen_tunjangan_anak"
                />
                <JetInputError
                    :message="form.errors.persen_tunjangan_anak"
                    class="mt-2"
                />
            </div>

            <!-- Tarif UMK -->
            <div class="col-span-6 sm:col-span-4">
                <JetLabel for="tarif_umk" value="Tarif UMK" />
                <Input
                    id="tarif_umk"
                    type="text"
                    class="mt-1 block w-full"
                    v-model="form.tarif_umk"
                    autocomplete="tarif_umk"
                />
                <JetInputError :message="form.errors.tarif_umk" class="mt-2" />
            </div>

            <!-- Tarif BPJS 1 -->
            <div class="col-span-6 sm:col-span-4">
                <JetLabel
                    for="persen_pot_bpjs_1"
                    value="Persen Pot BPJS Kshtn"
                />
                <Input
                    id="persen_pot_bpjs_1"
                    type="text"
                    class="mt-1 block w-full"
                    v-model="form.persen_pot_bpjs_1"
                    autocomplete="persen_pot_bpjs_1"
                />
                <JetInputError
                    :message="form.errors.persen_pot_bpjs_1"
                    class="mt-2"
                />
            </div>

            <!-- Tarif BPJS 1 -->
            <div class="col-span-6 sm:col-span-4">
                <JetLabel
                    for="persen_pot_bpjs_2"
                    value="Persen Pot BPJS Ktngj"
                />
                <Input
                    id="persen_pot_bpjs_2"
                    type="text"
                    class="mt-1 block w-full"
                    v-model="form.persen_pot_bpjs_2"
                    autocomplete="persen_pot_bpjs_2"
                />
                <JetInputError
                    :message="form.errors.persen_pot_bpjs_2"
                    class="mt-2"
                />
            </div>
        </template>

        <template #actions>
            <InertiaButtonSave
                :class="{ 'opacity-25': form.processing }"
                label="Simpan"
            />
        </template>
    </JetFormSection>
</template>

<script>
import { defineComponent } from "vue";
import JetFormSection from "@/Jetstream/FormSection";
import Input from "@/Components/Input";
import JetInputError from "@/Jetstream/InputError";
import JetLabel from "@/Jetstream/Label";
import InertiaButtonSave from "@/Components/InertiaButtonSave";

export default defineComponent({
    components: {
        JetFormSection,
        Input,
        JetInputError,
        JetLabel,
        InertiaButtonSave,
    },
    data() {
        return {
            form: this.$inertia.form({
                _method: "PUT",
                tarif_tunjangan_beras:
                    this.$page.props.setting.tarif_tunjangan_beras,
                persen_tunjangan_pasangan:
                    this.$page.props.setting.persen_tunjangan_pasangan,
                persen_tunjangan_anak:
                    this.$page.props.setting.persen_tunjangan_anak,
                tarif_umk: this.$page.props.setting.tarif_umk,
                persen_pot_bpjs_1: this.$page.props.setting.persen_pot_bpjs_1,
                persen_pot_bpjs_2: this.$page.props.setting.persen_pot_bpjs_2,
            }),
        };
    },
    methods: {
        updateSettingGaji() {
            this.form.post(route("setting.gaji.save"), {
                errorBag: "updateSettingGaji",
                preserveScroll: true,
                // onSuccess: () => (this.clearPhotoFileInput()),
            });
        },
    },
});
</script>
